import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  THinmeiDeleteReq,
  THinmeiInfoGetRes,
  THinmeiListGetReq,
  THinmeiRegisterPostReq,
} from "./THinmei"

/**
 * 品名マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class HinmeiService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {THinmeiListGetReq} params
   * @param {(param: TApiResponse<THinmeiInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<THinmeiInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: THinmeiListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<THinmeiInfoGetRes[]>> =
        await this.getInner(`/master/ninusihin`, params)
      if (params.荷主コード === "2" && params.品コード === "1") {
        // eslint-disable-next-line no-throw-literal
        throw "ERROR"
      }
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {id} id
   * @memberof MenuService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<THinmeiInfoGetRes>> =
        await this.getInner(`/master/ninusihin/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: THinmeiRegisterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/ninusihin`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (id: number, data: THinmeiRegisterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/ninusihin/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体削除
   *
   * @param {THinmeiDeleteReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof HinmeiService
   */
  delete = async (id: number, data: THinmeiDeleteReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.deleteInner(
        `master/ninusihin/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
